<section class="values" #root aria-labelledby="values-title">
  <!-- ============================================================
       BACKGROUND — radial light, mesh, faint grid, glow lines
       ============================================================ -->
  <div class="values__bg" #bg aria-hidden="true">
    <span class="values__glow values__glow--a"></span>
    <span class="values__glow values__glow--b"></span>
    <span class="values__mesh"></span>
    <span class="values__net"></span>
    <span class="values__wave values__wave--1"></span>
    <span class="values__wave values__wave--2"></span>
  </div>

  <!-- ambient motes, deepest parallax layer -->
  <div class="values__motes" #motes aria-hidden="true">
    <i class="values__mote"></i><i class="values__mote"></i>
    <i class="values__mote"></i><i class="values__mote"></i>
    <i class="values__mote"></i><i class="values__mote"></i>
    <i class="values__mote"></i><i class="values__mote"></i>
    <i class="values__mote"></i><i class="values__mote"></i>
    <i class="values__mote"></i><i class="values__mote"></i>
  </div>

  <div class="container values__inner">
    <!-- ============================================================
         HEADER
         ============================================================ -->
    <header class="values__head" #head>
      <span class="values__badge">
        <i class="values__badge-dot"></i>
        Our Core Values
      </span>

      <h2 class="values__title" id="values-title" #title>
        Our <span class="values__title-grad">Values</span>
      </h2>

      <span class="values__divider" aria-hidden="true">
        <i></i><em></em><i></i>
      </span>

      <p class="values__lede">
        The principles that guide our decisions, define our culture, and drive
        meaningful results for our clients.
      </p>
    </header>

    <!-- ============================================================
         GRID — 4 x 2
         ============================================================ -->
    <div class="values__grid" #grid>
      <app-value-card
        *ngFor="let it of items; trackBy: trackItem"
        #card
        [item]="it"
        [active]="open() === it.id"
        [dimmed]="open() !== null"
        (activate)="toggle(it.id)"
      ></app-value-card>
    </div>
  </div>
</section>
